<template>
        <div class="d-flex justify-content-center flex-column" :class="`align-items-${align}`">
        <div class="card shadow-sm mb-4 cursor-pointer">
            <div class="row no-gutters h-100">
                <div class="col-md-5 p-2" @click="$router.push({ name: 'product', params: { id: product.uuid } })">
                    <ImageSlider :images="images"/>
                </div>
                <div class="col-md-7">
                    <div class="card-body h-100 d-block d-sm-flex flex-column justify-content-between">
                        <div class="d-flex justify-content-between">
                            <h3 class="card-title">{{ product.name }}</h3>
                            <div class="card-location" :title="product.community.value">
                                <i class="fas fa-map-marker-alt"/> {{ product.community.value }}
                            </div>
                        </div>
                        <ul class="pl-4 list-unstyled">
                            <li class="text-truncate" v-for="item in specs.slice(0, 5)" :key="item.title">
                                <b>{{ item.title }}:</b> {{ item.value.subcatName }}
                            </li>
                            <li>
                                <RouterLink :to="{ name: 'product', params: { id: product.uuid } }">
                                    {{ translate('product_box.read_more') }}
                                </RouterLink>
                            </li>
                        </ul>
                        <div class="card-text d-flex justify-content-between align-items-end">
                            <div class="text-muted small d-flex">
                                <div :title="translate('product_box.viewed')">
                                    <i class="fa fa-eye"/> {{ product.threshhold }}
                                </div>
                                <div class="ml-2 ml-sm-3" :title="translate('product_box.sold')">
                                    <i class="fas fa-truck"/> {{ product.quantity }}
                                </div>
                                <div class="ml-2 ml-sm-3" :title="`${translate('product_box.will_be_ready_in')} ${product.completion_days} ${translate('product_box.days')}`">
                                    <i class="fas fa-calendar-check"/> {{ product.completion_days }} {{ translate('product_box.days')  }}
                                </div>
                            </div>
                            <div class="d-flex align-items-end ml-2">
                                <BookmarkButton :product-id="product.id" class="mr-1 mr-sm-3"/>
                                <ContactButton :product-id="product.id" @click="console.log(1)" :id="product.supplier.id" class="mr-1 mr-sm-3"/>                                <slot name="button"/>
                                <div v-if="!$slots.default" class="supp-img-mobile d-sm-none" @click="$router.push({ name: 'supplier', params: { id: product.supplier.id } })">
                                    <img width="70px" :src="product.supplier.image" alt="" class="rounded-circle">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!$slots.default" class="supp-img" @click="$router.push({ name: 'supplier', params: { id: product.supplier.id } })" :style="{backgroundImage: `url(${product.supplier.image})`}">
                </div>
                <div class="supp-img" v-else>
                    <slot/>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ImageSlider from '../ImageSlider'
import BookmarkButton from './BookmarkButton'
import ContactButton from './ContactButton'

//import services from '../../assets/json/services'

export default {
    name: "ProductBox",
    components: {ContactButton, BookmarkButton, ImageSlider},
    props: {
        product: {
            required: true,
            type: Object
        },
        align: {
            type: String,
            default: 'center'
        },
        showContact:{
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            showContactModal: false,
            showBookmarkModal: false,
        }
    },
    computed: {
        images () {
            return [
                {path: this.product.image},
                {path: this.product.image2},
                {path: this.product.image3},
                {path: this.product.image4},
            ]
        },
        specs () {
            //const service = services.find(({name}) => name === this.product.service)
            //const specs = service ? service.specs : []
            return [
                {title: this.product.service.speca || 'Spec 1', value: this.product.p3},
                {title: this.product.service.specb || 'Spec 2', value: this.product.p4},
                {title: this.product.service.specc || 'Spec 3', value: this.product.p5}
            ]
        },
    }
}
</script>

<style scoped lang="scss">
    .card {
        position: relative;
        max-width: 100%;

        .supp-img {
            position: absolute;
            left: 100%;
            height: 100%;
            max-width: 250px;
            width: 0;
            overflow: hidden;
            transition: width .3s;
            cursor: pointer;
            background-position: center;
            background-repeat: no-repeat;
        }
        .card-title {
            max-width: 320px;
            @media (max-width: 576px) {
                max-width: 70%
            }
        }
        .card-location {
            max-width: 96px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

    }

    @media (max-width: 768px) {
        .card {
            .supp-img {
                left: 0;
                top: 0;
                height: auto;
                max-width: 100%;
                transition: width 0s, height .3s;
            }
        }
        .card:hover .supp-img {
            width: 100%;
            top: 100%;
            left: 0;
            z-index: 1;
            height: auto;
        }
    }

    @media (min-width: 768px) {

        .card {
            width: 768px;
            height: 300px;

            .supp-img {
                left: 0;
                top: 0;
                height: auto;
                max-width: 100%;
                transition: width 0s, height .3s;
            }
        }

        .card:hover .supp-img {
            width: 100%;
            top: 100%;
            left: 0;
            z-index: 1;
            height: auto;
        }
    }

    @media (min-width: 1024px) {

        .card {
            width: 768px;
            height: 300px;
        }

        .card:hover .supp-img {
            width: 250px;
            top: 0;
            left: 100%;
            height: 100%;
        }
    }
</style>
